<template>
  <div class="wrapper-list-attached-logos">
    <b-loading :active="isLoading" />
    <div>
      <div
        v-if="!isMobile && listImages.length"
        slot="header"
        role="group"
        class="mb-15 is-flex"
      >
        <div class="list-header columns m-0 is-mobile is-vcentered">
          <div class="column is-flex is-narrow p-0 width-30">
            <img
              :src="isContrast ? arrowsContrast : arrows"
              width="15"
              height="15"
              alt=""
            />
          </div>
          <div class="column p-0">
            <div class="columns ml-10 is-mobile">
              <span class="column is-5 is-size-7">{{
                General.DOCUMENTS_ATTACHED
              }}</span>
              <span class="column is-6 is-size-7">{{
                General.APPLICABLE_TO
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <draggable
        v-model="listImages"
        class="list-group spacing-mx-10"
        :class="{ 'mt-10 mx-0': isMobile }"
        ghostClass="ghost"
        handle=".handler"
      >
        <div v-for="(image, index) in listImages" :key="index" class="columns">
          <img
            v-if="!isMobile"
            :src="alignJustify"
            width="15"
            height="15"
            class="handler"
            alt=""
          />
          <b-input
            :value="image.name"
            disabled
            class="column is-5"
            minlength="1"
          />
          <b-taginput
            v-model="listImages[index].document_type"
            :data="filterTypes"
            autocomplete
            field="type"
            name="id"
            class="column is-6"
            :placeholder="General.TYPE_IT_SEARCH"
            rounded
            :hasCounter="false"
            @typing="getFilterTypes"
          >
            <template slot-scope="props">
              <span>{{ props.option.type }}</span>
            </template>
            <template slot="empty">
              <p v-if="!isLoading">
                {{ General.MESSAGES.NO_RECORDS_FOUND.toUpperCase() }}
              </p>
              <b-loading v-else :isFullPage="false" :active="isLoading" />
            </template>
          </b-taginput>
          <div class="column">
            <b-button class="button-add" @click="removeAttachedLogo(index)">
              <b-icon
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
                icon="delete"
              />
            </b-button>
          </div>
        </div>
      </draggable>
    </div>
    <slot name="detail" />
    <div class="buttons mt-20 mb-10">
      <ImgCutter
        :rate="getImageRate"
        :label="App.PartAddressScreen.CHANGE_IMAGE"
        :class="{ 'is-full': isMobile }"
        @cutDown="img => checkFile(img.file)"
      >
        <template #openImgCutter>
          <button class="upload-button">
            <b-icon icon="upload" class="spacing-mr-10" />
            <span>
              {{ App.PartAddressScreen.ATTACH_FILE }}
            </span>
          </button>
        </template>
      </ImgCutter>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapMutations } from "vuex";

import { App, General } from "@/utils/constants";
import arrows from "@/assets/svg/arrows.svg";
import arrowsContrast from "@/assets/svg/arrows_contrast.svg";
import alignJustify from "@/assets/svg/align-justify-solid.svg";
import { toBase64 } from "@/utils/fileUtility";
import ImgCutter from "@/components/ImgCutter";

export default {
  name: "ListAttachedLogos",
  components: {
    draggable,
    ImgCutter
  },
  props: {
    isVertical: {
      type: Boolean,
      default: false
    },
    isLinked: {
      type: Boolean,
      default: false
    },
    imageList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      App,
      General,
      arrows,
      arrowsContrast,
      alignJustify,
      filterTypes: [],
      isLoading: false,
      listImages: []
    };
  },

  computed: {
    ...mapGetters({
      fileTypes: "getFileTypes",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getImageRate() {
      if (this.isVertical) return "1.38:1";
      if (this.isLinked) return "11.2:2";
      return "5:2";
    }
  },

  watch: {
    imageList() {
      this.listImages = this.imageList;
    },
    listImages() {
      this.isVertical
        ? this.setListVerticalLogos(this.listImages)
        : this.setListHorizontalLogos(this.listImages);
    }
  },

  beforeMount() {
    this.listImages = [...this.imageList];
  },

  methods: {
    ...mapMutations({
      setListHorizontalLogos: "setListHorizontalLogos",
      setListVerticalLogos: "setListVerticalLogos"
    }),

    getFilterTypes(text) {
      this.filterTypes = this.fileTypes.filter(option =>
        option.type.toLowerCase().includes(text.toLowerCase())
      );
    },

    async checkFile(logo) {
      const msg = [];
      if (logo.type !== "image/png")
        msg.push(App.PartAddressScreen.MESSAGES.INVALID_FORMAT);

      if (logo.size > this.maxFileSize)
        msg.push(App.PartAddressScreen.MESSAGES.EXCEEDED_SIZE);

      if (msg.length) {
        this.snackToast.open({
          message: `${
            App.PartAddressScreen.MESSAGES.FILE_CANT_ATTACHED
          }: ${msg.join(", ")}.`,
          type: "is-danger",
          duration: 8000
        });
      } else {
        const logoB64 = await toBase64(logo);
        const regex = /,(.+)/g;
        this.listImages.push({
          logo_type: this.isVertical
            ? this.App.PartAddressScreen.LOGO_TYPE.VERTICAL
            : this.App.PartAddressScreen.LOGO_TYPE.HORIZONTAL,
          name: logo.name,
          isNew: true,
          image: regex.exec(logoB64)[1],
          document_type: null
        });
      }
    },

    removeAttachedLogo(index) {
      this.listImages.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.custom-list {
  display: flex;
  justify-content: flex-start;
}

.custom-list li {
  font-weight: 500;
  padding: 5px 0;
}

.custom-list li:nth-child(1) {
  display: flex;
  flex: 0.4;
}

.custom-list li:nth-child(2) {
  display: flex;
  flex: 0.3;
}

.list-header {
  font-weight: bold;
  width: 100%;
}

.ghost {
  opacity: 0.5;
  background-color: #dcdcdc;
}
.container-attached-doc {
  display: flex;
}

.handler {
  cursor: move;
  opacity: 0;
}

.container-attached-doc:hover .handler {
  opacity: 1;
}

.upload-button {
  display: flex;
  align-items: center;
  background-color: transparent;
  border-color: $color-12;
  border: 1px solid;
  border-radius: 4px;
  color: $color-12;
  cursor: pointer;
  padding: calc(0.5em - 1px) 1em calc(0.5em - 1px) 1em;

  white-space: nowrap;

  height: 2.5em;
  user-select: none;

  @media screen and (max-width: $tablet) {
    width: 100%;
    justify-content: center;
  }
}

.button-add {
  width: 20px;
  margin: 0px 5px;
  cursor: pointer;
  border: none;
  background-color: transparent;

  @media screen and (max-width: 767px) {
    justify-self: center;
  }
}
</style>

<style lang="scss">
.wrapper-list-attached-logos {
  .dropdown-content {
    @media screen and (min-width: 1024px) {
      min-width: 220px;
    }
  }
}
</style>
